import './src/styles/global.css'
import { Amplify } from 'aws-amplify'
import awsconfig from './src/amplifyconfiguration.json'
Amplify.configure(awsconfig)

// gatsby-browser.js
export { wrapRootElement } from './src/providers'
